export default "__VITE_ASSET__0286424b__"